import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { SecureStorageService } from './secureStorage.service'
@Injectable({providedIn: 'root'})
export class AuthTokenService {
  constructor(
    private http: HttpClient,
    private secureStorageService: SecureStorageService
  ) {
  }

  getToken() {
    return this.secureStorageService.secureLocalStorage.getItem('authenticationToken') || this.secureStorageService.secureSessionStorage.getItem('authenticationToken'); 
  }

  storeAuthenticationToken(jwt, rememberMe) {
    if (rememberMe) {
      this.secureStorageService.secureLocalStorage.setItem('authenticationToken',jwt.jSessionId)
    } else {
      this.secureStorageService.secureSessionStorage.setItem('authenticationToken',jwt.jSessionId); 
    }
  }

  clearToken() {
    this.secureStorageService.secureLocalStorage.clear();
    this.secureStorageService.secureSessionStorage.clear();
  }
}
